import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { UserRole, hasRole, hasPermission } from '../services/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireRole?: UserRole;
  requirePermission?: string;
  requireCreator?: boolean; // Deprecated: use requireRole instead
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireRole,
  requirePermission,
  requireCreator = false
}) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-dark-950 flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Role-based access control
  if (requireRole && !hasRole(requireRole)) {
    console.log(`ProtectedRoute: User does not have required role: ${requireRole}`);
    return <Navigate to="/" replace />;
  }

  // Permission-based access control
  if (requirePermission && !hasPermission(requirePermission)) {
    console.log(`ProtectedRoute: User does not have required permission: ${requirePermission}`);
    return <Navigate to="/" replace />;
  }

  // Legacy creator check (deprecated)
  if (requireCreator && !hasRole(UserRole.CREATOR)) {
    console.log('ProtectedRoute: User is not a creator, redirecting to home');
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;